<script>
import { XCircleIcon } from 'vue-feather-icons'

export default {
  name: 'DeliveryRequestSearchInfo',
  props: {
    search: Object,
    deliveryScenario: String,
    outgoing: Boolean,
  },
  components: {
    XCircleIcon,
  },
}
</script>

<template lang="pug">
.search-info(
  v-if="(deliveryScenario == 'by_user' && !!this.search.user.text.length) || (deliveryScenario == 'by_deliverer' && this.outgoing && !!this.search.delivererOutgoing.text.length) || (deliveryScenario == 'by_deliverer' && !this.outgoing && !!this.search.delivererIncoming.text.length)"
)
  .text-secondary
    span.font-weight-bold.mr-1 Wyszukiwany Tekst:
    span(v-if="deliveryScenario == 'by_user'") {{ this.search.user.text }}
    span(v-else-if="deliveryScenario == 'by_deliverer' && this.outgoing") {{ this.search.delivererOutgoing.text }}
    span(v-else-if="deliveryScenario == 'by_deliverer' && !this.outgoing") {{ this.search.delivererIncoming.text }}
  x-circle-icon.close-icon(@click="$emit('resetSearch')" size="1.5x")
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.search-info {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.close-icon {
  padding: 1rem;
  margin: -1rem;
  box-sizing: content-box;
  color: $secondary;
}
</style>
